import Model, { attr } from '@ember-data/model';

const REPLACEABLE_WITHIN_MS = 60 * 60 * 1000;

export default class TaskAttachmentModel extends Model {
  @attr('string') contentType!: string;
  @attr('number') byteSize!: number;
  @attr('string') digest!: string;
  @attr('string') capturedAt!: string;
  @attr('boolean') image!: boolean;
  @attr('string') outgoingBookingId?: string;
  @attr('string') incomingBookingId?: string;
  @attr('string') uploadedByName?: string;
  @attr('string') url?: string;

  // Write-only: sent when confirming or replacing an upload, never returned by the serializer.
  @attr('string') bucket?: string;
  @attr('string') key?: string;

  @attr('string') taskId?: string;
  @attr('string') taskChecklistItemId?: string;

  // Not @cached: Date.now() isn't a tracked dependency, so caching this would freeze
  // the answer at whatever it was the first time it was read.
  get isReplaceable(): boolean {
    if (!this.capturedAt) {
      return false;
    }

    return Date.parse(this.capturedAt) + REPLACEABLE_WITHIN_MS > Date.now();
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'task-attachment': TaskAttachmentModel;
  }
}
